import i18n from '@app/i18n';
import { DependencyType, VisibilityType } from '@data/sdk/match';

const expiryMap = (): Record<string, number | null> => ({
  [i18n.t('admin:expiry.6_months')]: 6 * 30 * 24 * 60 * 60,
  [i18n.t('admin:expiry.3_months')]: 3 * 30 * 24 * 60 * 60,
  [i18n.t('admin:expiry.1_year')]: 365 * 24 * 60 * 60,
  [i18n.t('admin:expiry.never')]: null,
});

export const expiryOptions = () =>
  Object.entries(expiryMap()).map(([key, value]) => ({
    label: key,
    value,
  }));

export const getQuestionExpiry = (expiry: number | null) => {
  const map = expiryMap();
  const key = Object.keys(map).find((k) => map[k as keyof typeof map] === expiry);
  return key || '';
};

export const getQuestionVisibilityOptions = () => [
  { label: i18n.t('admin:question_visibility.default'), value: VisibilityType.Default },
  { label: i18n.t('admin:question_visibility.first'), value: VisibilityType.First },
  { label: i18n.t('admin:question_visibility.hidden'), value: VisibilityType.Hidden },
];

export const getProcessorOptions: () => { label: string; value: DependencyType }[] = () => [
  { label: i18n.t('admin:question_dependency.equalTo'), value: DependencyType.EqualTo },
  { label: i18n.t('admin:question_dependency.greaterThan'), value: DependencyType.GreaterThan },
  { label: i18n.t('admin:question_dependency.dateToMonths'), value: DependencyType.DateToMonths },
  { label: i18n.t('admin:question_dependency.dateToYears'), value: DependencyType.DateToYears },
];
